/* Enhancement for product.immersive only; Shopify's product form owns cart requests. */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (n) => Math.max(0, Math.min(1, n));

  function enhanceProduct(root) {
    if (root.dataset.ciReady) return;
    root.dataset.ciReady = 'true';
    const form = root.querySelector('product-form-component form');
    const picker = root.querySelector('calmaura-pack-picker');
    if (!form || !picker) return;
    const quantity = form.querySelector('input[name="quantity"]');
    if (!quantity) return;
    const choices = [...picker.querySelectorAll('input[type="radio"]')];
    const total = root.querySelector('[data-ci-total]');
    const sticky = document.querySelector('[data-ci-sticky]');
    const submit = form.querySelector('button[type="submit"]');
    let selected = choices.find((choice) => choice.checked) || choices[0];
    // Integration hook: no network requests or analytics identifiers are created here.
    const emit = (event, extra = {}) => {
      root.dispatchEvent(new CustomEvent('calmaura:buybox', { bubbles: true, detail: {
        event, variant: 'pricing-sop-v1', quantity: Number(selected.value),
        value: Number(selected.dataset.ciCents) / 100, currency: 'USD', ...extra
      }}));
    };
    const exposureObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { emit('view_buy_box'); exposureObserver.disconnect(); }
    }, { threshold: 0.25 });
    exposureObserver.observe(picker);
    function sync() {
      // Appstle intercepts requests using its own state. Use its real controls before
      // writing the native quantity; changing FormData alone does not change that state.
      const oneTime = root.querySelector('.appstle_one_time_details_wrapper input[type="radio"]')
        || root.querySelector('input[name="selling_plan"][value=""]:not([data-appstle-real-value])');
      if (oneTime) oneTime.click();
      const volume = document.querySelector(`.ab-volume-discount-item-${selected.value}`);
      if (volume) volume.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      const liveQuantity = form.querySelector('input[name="quantity"]');
      if (liveQuantity) {
        const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
        setter.call(liveQuantity, selected.value);
        liveQuantity.dispatchEvent(new Event('input', { bubbles: true }));
        liveQuantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (total) total.textContent = selected.dataset.ciMoney;
      const count = Number(selected.value);
      const rewards = picker.querySelector('[data-ci-rewards]');
      if (rewards) {
        rewards.dataset.level = count;
        rewards.querySelectorAll('[data-ci-step]').forEach(step => {
          const unlocked = Number(step.dataset.ciStep) <= count;
          step.classList.toggle('is-unlocked', unlocked);
          step.querySelector('span').textContent = unlocked ? '✓' : step.dataset.ciStep;
        });

      }
      const summary = root.querySelector('[data-ci-summary]');
      if (summary) summary.textContent = `${count * 30} servings · ${count > 1 ? 'Free shipping' : 'Shipping at checkout'}`;
      const atcText = submit?.querySelector('.add-to-cart-text__content');
      if (atcText) atcText.textContent = `Add to cart · ${selected.dataset.ciMoney}`;
      const stickyPrice = sticky?.querySelector('[data-ci-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = selected.dataset.ciMoney;
    }
    picker.addEventListener('change', (event) => {
      if (!choices.includes(event.target)) return;
      const previousQuantity = Number(selected.value);
      selected = event.target;
      sync();
      emit('select_pack', { previousQuantity, source: 'card' });
    });
    // Synchronize before Horizon constructs FormData, including after delayed app initialization.
    form.addEventListener('submit', () => { sync(); emit('add_to_cart_attempt'); }, { capture: true });
    submit?.addEventListener('click', sync, { capture: true });
    root.querySelectorAll('.pu-option,.pu-tubes,#volumeDiscountContainer').forEach((element) => {
      element.inert = true;
      element.setAttribute('aria-hidden', 'true');
    });
    sync();
    picker.hidden = false;
    root.classList.add('ci-ready');

    const miniUGC = root.querySelector('[data-ci-ugc]');
    if (miniUGC) {
      const findClip = button => [...document.querySelectorAll('.cugc-modal__media[data-video]')]
        .find(media => media.dataset.video.includes(button.dataset.ciUgcClip));
      let available = 0;
      miniUGC.querySelectorAll('[data-ci-ugc-clip]').forEach(button => {
        const media = findClip(button);
        button.hidden = !media;
        if (!media) return;
        available++;
        button.addEventListener('click', () => {
          const target = findClip(button);
          const modal = target?.closest('.cugc-modal');
          const slide = target?.closest('[data-cugc-slide-i]');
          const section = modal?.closest('.cugc');
          const card = section?.querySelector(`[data-cugc-i="${slide?.dataset.cugcSlideI}"]`);
          if (!card) return;
          // The existing player owns playback. Retain keyboard focus in the buy box.
          modal.addEventListener('close', () => button.focus({ preventScroll: true }), { once: true });
          emit('open_customer_video', { clip: button.dataset.ciUgcClip, source: 'buy_box' });
          card.click();
        });
      });
      miniUGC.hidden = available === 0;
    }

    const track = root.querySelector('[data-ci-gallery-track]');
    if (track) {
      const slides = [...track.children];
      const thumbs = [...root.querySelectorAll('[data-ci-slide]')];
      let index = 0;
      const go = next => track.scrollTo({ left: ((next + slides.length) % slides.length) * track.clientWidth, behavior: motion.matches ? 'instant' : 'smooth' });
      const update = () => {
        index = Math.round(track.scrollLeft / track.clientWidth);
        root.querySelector('[data-ci-gallery-count]').textContent = `${index + 1} / ${slides.length}`;
        thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      };
      root.querySelectorAll('[data-ci-gallery-controls]').forEach(el => { el.hidden = false; });
      root.querySelector('[data-ci-gallery-prev]').addEventListener('click', () => go(index - 1));
      root.querySelector('[data-ci-gallery-next]').addEventListener('click', () => go(index + 1));
      thumbs.forEach((button, i) => button.addEventListener('click', () => go(i)));
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
      });
      new ResizeObserver(update).observe(track);
    }
    root.querySelector('.ci-pack-source a[href="#calmaura-vs-nello"]')?.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById('calmaura-vs-nello');
      if (!target) return;
      event.preventDefault();
      if (location.hash !== '#calmaura-vs-nello') history.pushState(null, '', '#calmaura-vs-nello');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: 'instant', block: 'start' });
    });
    root.querySelector('.jdgm-prev-badge')?.addEventListener('click', (event) => {
      const target = document.getElementById('reviews-anchor');
      if (target) { event.preventDefault(); target.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth' }); }
    });
    if (sticky && submit) {
      const observer = new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting; }, { threshold: 0 });
      observer.observe(submit);
      sticky.querySelector('a')?.addEventListener('click', (event) => {
        event.preventDefault();
        picker.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'center' });
        selected.focus({ preventScroll: true });
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) observer.disconnect();
      }, { once: true });
    }
  }

  class IngredientReveal extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      this._frame = 0;
      this._replaying = false;
      const button = this.querySelector('[data-ci-replay]');
      this._update = () => {
        this._frame = 0;
        if (motion.matches || this._replaying) return;
        const scene = this.querySelector('.ci-reveal__scene').getBoundingClientRect();
        const progress = clamp((innerHeight * .83 - scene.top) / (innerHeight * .58));
        this.style.setProperty('--open', progress.toFixed(4));
        if (button) button.innerHTML = `${progress > .8 ? 'Replay the reveal' : 'Open the tub'} <span aria-hidden="true">↗</span>`;
      };
      const schedule = () => {
        if (this._visible && !this._frame) this._frame = requestAnimationFrame(this._update);
      };
      this._observer = new IntersectionObserver(([entry]) => {
        this._visible = entry.isIntersecting;
        if (this._visible) schedule();
      }, { rootMargin: '160px' });
      this._observer.observe(this);
      window.addEventListener('scroll', schedule, { passive: true, signal });
      window.addEventListener('resize', schedule, { passive: true, signal });
      motion.addEventListener('change', () => { this.style.setProperty('--open', '1'); schedule(); }, { signal });
      if (button) {
        button.hidden = motion.matches;
        button.addEventListener('click', () => {
          if (motion.matches || this._replaying) return;
          this._replaying = true;
          const from = parseFloat(this.style.getPropertyValue('--open')) || 0;
          let started;
          const animate = (now) => {
            if (!this.isConnected) return;
            started ??= now;
            const time = now - started;
            const close = clamp(time / 280);
            const open = clamp((time - 350) / 1050);
            const eased = open * open * (3 - 2 * open);
            const value = time < 350 ? from * (1 - close) : eased;
            this.style.setProperty('--open', value.toFixed(4));
            if (time < 1400) this._animation = requestAnimationFrame(animate);
            else { this._replaying = false; button.innerHTML = 'Replay the reveal <span aria-hidden="true">↗</span>'; }
          };
          this._animation = requestAnimationFrame(animate);
        }, { signal });
      }
      this._update();
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._observer?.disconnect();
      cancelAnimationFrame(this._frame);
      cancelAnimationFrame(this._animation);
    }
  }
  if (!customElements.get('calmaura-ingredient-reveal')) customElements.define('calmaura-ingredient-reveal', IngredientReveal);
  function init() { document.querySelectorAll('[data-ci-product]').forEach(enhanceProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
